export default __webpack_public_path__ + "static/media/HowItWorks-02.38d6f853.jpg";